import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../config/withDirection';

const WidgetWrapper = styled.div`
  margin: 0 10px;

  @media only screen and (max-width: 767) {
    margin-right: 0 !important;
  }

  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
`;
const HomeWrapper = styled.div`

// temp fix for ugly textarea
    input:not([type="radio"]):not([type="checkbox"]), textarea {
        padding: 0rem; 
    }
    .ant-col-md-12 {
        margin-left: auto;
        margin-right: auto;
    }
    

    .rc-tabs-top{
        overflow-y: hidden;
    }
    .rc-tabs-ink-bar{
        background-color: rgba(60, 211, 207, 1);
    }
    .rc-tabs-tab{
        font-family: 'Montserrat';
        font-size: 15px;
        color: rgba(64, 55, 57, 1);
    }
    .rc-tabs-tab:hover {
        color: rgba(64, 55, 57, 1);
    }
    .rc-tabs-tab-active {
        font-family: 'Montserrat';
        font-size: 15px;
        color: rgba(64, 55, 57, 1);
    } 
    .rc-tabs-tab-active:hover {
        color: rgba(64, 55, 57, 1);
    }

    .inputWrapper {
        padding-left: 10px;
        font-family: 'Montserrat';
        font-size: 20px;
        color: rgba(64, 55, 57, 1);
        text-align: center;
        letter-spacing: 0.03em;
        line-height: 18px;
        font-family: 'Montserrat-Light';
        font-size: 16px;
        margin-bottom: 16px;

        .FormTextInput {
            height: 40px;
            border: 1px solid rgba(151, 151, 151, 1);
            border-radius: 20px;
            padding-left: 20px;
            padding-right: 20px;
            display: flex;

            div {
                margin: 8px;
                font-family: 'Montserrat';
                font-size: 14px;
                font-weight: 300;
                color: rgba(147, 147, 147, 1);
                text-align: left;
                letter-spacing: 0.07em;
            }
    
            input {
                width: 100%;
                border: none;
            }

            input:focus{
                outline: unset;
            }

            input[type=number] {
                height: 38px;                
                min-width: 9rem;
                border: none;
                width: 3px;
                border-left: 1px solid rgba(151, 151, 151, 1);
            }
            
        }
        
        .react-tagsinput {
            width: 213px;
            border: 1px solid rgba(151,151,151,1);
            border-radius: 20px;
            display: -webkit-inline-box;

            span {
                padding-left: 10px;
            }
        }
    
        label {
            left: -32px;
            position: relative;
            width: 213px;
            height: 17px;
            font-family: 'Montserrat';
            font-size: 14px;
            color: rgba(64, 55, 57, 1);
            text-align: left;
            letter-spacing: 0.04em;
            display: -webkit-inline-box;
        }
    
    }

    .isoInputWrapper {
        margin-bottom: 15px;
        justify-content: center;
        align-items: center;
        vertical-align: center;
        display: flex;
        border: 1px solid rgba(147, 147, 147, 1);
        border-radius: 20px;

        &:last-of-type {
          margin-bottom: 0;
        }
        .searchIcon{
          width: 18px;
          height: 18px;
        }
      
        .searchInput{
          width: 250px;
          display: inline-block;

          .Select-control {
            border: none;
            background-color: rgba(0,0,0,0.1);

            .Select-input:focus {
                background: rgba(255, 255, 255, 1);
                font-family: 'Montserrat';
                font-size: 14px;
                color: rgba(147, 147, 147, 1);
                text-align: justify;
                letter-spacing: 0.04em;
            }
          }
          .Select-placeholder {
            font-size: 14px;
            color: rgba(147, 147, 147, 1);
            text-align: justify;
            letter-spacing: 0.04em;
            line-height: 17px;
            font-family: 'Montserrat';
          }
          .Select-value{
            font-size: 14px;
            color: rgba(147, 147, 147, 1);
            text-align: justify;
            letter-spacing: 0.04em;
            line-height: 17px;
            font-family: 'Montserrat';
          }

          input{
            border: none;
          }
          
        }
        .regionInput{
          display: inline-block;
          .country-flag img{
            top: 0;
          }

          span{
            font-size: 14px;
            color: rgba(147, 147, 147, 1);
            text-align: justify;
            letter-spacing: 0.04em;
          }
        }
    }


    // ENd of resuable componetns

    .blackSection {
        background-color: rgba(35, 31, 32, 1);
        color: #fff;
        position: relative;
        z-index: 12;
        box-shadow: 0px 2px 4px 0px rgba(122, 122, 122, 0.5);
        .appDisplay__app-display {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
                -ms-flex-align: center;
                    align-items: center; }
    }

    

    .o-wrapper {
        padding-top: 16px;

        max-width: 1020px;
        padding-right: 1.5rem;
        padding-left: 1.5rem;
        margin-right: auto;
        margin-left: auto; }
        @media (min-width: 768px) {
          .o-wrapper {
            padding-right: 40px;
            padding-left: 40px; } }
        @media (min-width: 1281px) {
          .o-wrapper {
            max-width: 1120px;
            padding-right: 1.5rem;
            padding-left: 1.5rem; } }

    .appDisplayImg__app-display {
        padding-right: 0.75rem; }
        .appDisplayImg__app-display > img {
          border: 1px solid #D8D8D8;
          width: 3.25rem;
          height: 3.25rem;
          max-width: none;
          border-radius: 1rem; }
        @media (min-width: 480px) {
          .appDisplayImg__app-display {
            padding-right: 1.5rem; }
            .appDisplayImg__app-display > img {
              width: 4.25rem;
              height: 4.25rem; } }
      
    .appName__app-display,
    .appLongName__app-display {
        margin-top: 0px;

        font-family: 'Montserrat';
        font-size: 22px;
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
        text-align: left;
        letter-spacing: 0.09em;
        /*Text styles for S */
        font-family: 'Montserrat';
        font-size: 22px;
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
        text-align: left;
    }
        // @media (min-width: 480px) {
        //   .appName__app-display,
        //   .appLongName__app-display {
        //     font-size: 2rem; } }
        // @media (min-width: 1281px) {
        //   .appName__app-display,
        //   .appLongName__app-display {
        //     font-size: 2.25rem; } }
      
    .appPublisher__app-display {
        font-family: 'Montserrat';
        font-size: 14px;
        color: rgba(255, 255, 255, 1);
        text-align: left;
        letter-spacing: 0.07em;
        margin-top: 8px;

    }
    .appPublisher__app-display > span {
        display: table-cell;
        overflow: hidden;
        text-overflow: ellipsis; }
    @media (min-width: 480px) {
        .appPublisher__app-display {
        font-size: 1.2rem; } }
      
    .appDisplayConcise__app-display .appDisplayImg__app-display {
    padding-right: 0.75rem; }
    .appDisplayConcise__app-display .appDisplayImg__app-display > img {
        width: 36px;
        height: 36px;
        border-radius: 5px; }
    



    .mainAppScreen {
        background: rgba(243, 243, 243, 1);
        background-size: cover;
        display: table;
        height: 100%;
        width: 100%;
        width: 100%;
        min-height: 100vh;
        height: 100vh;
    }

    .startWrapper {
        font-family: 'Montserrat';
        font-size: 20px;
        color: rgba(64, 55, 57, 1);
        text-align: center;
        letter-spacing: 0.03em;
        line-height: 18px;
        font-family: 'Montserrat-Light';
        font-size: 16px;
        color: rgba(64, 55, 57, 1);
        text-align: center;
        letter-spacing: 0.03em;
        line-height: 18px;

        .firstLine {
            font-family: 'Montserrat';
            font-size: 20px;
            color: rgba(64, 55, 57, 1);
            margin-bottom: 20px;

        }

        .secondLine {
            font-family: 'Montserrat-Light';
            font-size: 16px;
            color: rgba(64, 55, 57, 1);
            text-align: center;
            letter-spacing: 0.03em;
            line-height: 18px;
            margin-bottom: 26px;

        }
    }
    
    .exampleHolder > div {
        margin-left: auto;
        margin-right: auto; 
    }
    @media (min-width: 768px) {
        .exampleHolder {
        position: absolute;
        width: 80%;
        right: 0;
        } 
    }
    
    @media (min-width: 850px) {
        .exampleHolder {
            width: 100%; 
        } 
    }
    
    
    .iPhone{
        width: 100%;
        z-index: 999;
    }


    .adExample__ad-example {
        width: 100%;
        max-width: 22rem;
        overflow: hidden;
        position: relative;
        margin-top: 3rem;
        }
        @media (min-width: 768px) {
          .adExample__ad-example {
            margin-top: 0;
            margin-right: 0; } }
        @media (min-width: 1281px) {
          .adExample__ad-example {
            /* max-width: 24rem; */
            } }
        .adExample__ad-example.centered__ad-example {
          margin-left: auto;
          margin-right: auto; }

    

    .container__ad-example {
        position: absolute;
        top: 34.15133%;
        width: 88.03030303030303%;
        left: 6.1%; }

    .adExampleFull__ad-example .container__ad-example {
        top: 18.759231905465288%; }

    .searchTerm__ad-example {
        position: absolute;
        top: 14.9%;
        left: 14.2%;
        font-size: 0.7rem; }
        @media (min-width: 480px) {
            .searchTerm__ad-example {
            font-size: 0.8rem; } }


    .app__ad-example {
        padding: 3.787878787878788%;
        background: #fff; }
        
    .app__ad-example.isAd__ad-example {
        background: #EDF6FF; }
    

    .appSummary__ad-example {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center; }

    .appThumbnail__ad-example {
        width: 27.03583%;
        margin-right: 2.9316%;
        -ms-flex-negative: 0;
            flex-shrink: 0; }
    .appThumbnail__ad-example > img {
        border-radius: 16px; }

    .appName__ad-example {
        font-size: 1.05em;
        color: #333;
        line-height: 1.2;
        margin-bottom: 5px; }
        
    .appDetail__ad-example {
        font-family: "SF UI", helvetica, arial, sans-serif;
        font-size: 0.75rem; }
              
    .getButton__ad-example {
        position: relative;
        padding: 0.3rem 0.5rem;
        border: 1px solid #3E90F4;
        color: #3E90F4;
        font-size: 0.65rem;
        font-family: "SF UI", helvetica, arial, sans-serif;
        border-radius: 3px;
        line-height: 1; }
        .getButton__ad-example::before {
            content: '+';
            position: absolute;
            line-height: 1;
            font-size: 7px;
            font-weight: 400;
            top: 0;
            left: 1px; }
    
    .adSymbol__ad-example {
        display: inline-block;
        padding: 0 5px;
        background: #8EC5FE;
        color: #fff;
        border-radius: 2px;
        margin-right: 8px; }
              
    .publisher__ad-example {
        font-size: 0.9em;
        color: #666;
        line-height: 1.3;
        display: table;
        table-layout: fixed;
        width: 100%;
        white-space: nowrap; }

    .publisher__ad-example > span {
        display: table-cell;
        overflow: hidden;
        text-overflow: ellipsis; }

    .screenshotsContainer__ad-example {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: distribute;
            justify-content: space-around;
        margin-top: 4.09%;
        width: 100%;
        // padding-left: 10.3226%;
        // padding-right: 10.3226%; 
    }
        
    .screenshot__ad-example {
        width: 30%; 
    }
    .screenshot__ad-example > img {
        width: 100%; 
    }

    .exampleHolder {
        position: relative;

        .searchTerm__ad-example { 
            top: 9.5%; 
            left: 19.2%; 
            z-index: 999;
        }
        .container__ad-example { top: 15.4%; width: 87.5%; }
    }



    .isoWidgetsWrapper{

        margin-left: auto;
        margin-right: auto;
        // height: 487px;
        width: 343px;
        background-color: rgba(255, 255, 255, 1);
    }

    .searchTerm__ad-example { top: 72px !important; }

    @media screen and (min-width: 850px) {
        .searchTerm__ad-example { top: 72px !important; }
    }

    @media screen and (min-width: 768px) and (max-width: 849px) {
        .searchTerm__ad-example { top: 58px !important; }
    }

    @media screen and (max-width: 767px) {
        .searchTerm__ad-example { top: 10.2% !important; }
    }
`;
// export default WithDirection(HomeWrapper);
export { WidgetWrapper, HomeWrapper };



// WEBPACK FOOTER //
// ./src/containers/Home/style.js